import styled from 'styled-components'

import Picture from '../../atoms/Picture'
import { mq, sizes } from '../../../theme'
import Html from '../../atoms/Html'
import VideoContent from '../../atoms/Video'
import ActionButton from '../../atoms/ActionButton'

export const ArticleBlock = styled.section`
  &:not(:first-child) {
    margin-top: 4rem;
  }
`

export const Content = styled.div`
  display: grid;
  grid-gap: 1.5rem 4rem;
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.titleH4};
  color: ${({ theme }) => theme.colors.arapawa};
  margin: 0;
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.titleH3};
  }
`
export const Text = styled(Html)`
  ${({ theme }) => theme.textStyles.textSmall};
  color: ${({ theme }) => theme.colors.arapawa};

  & a {
    color: ${({ theme }) => theme.colors.arapawa};
    text-decoration: underline;
  }

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.textMedium};
  }
`

export const StyledVideo = styled(VideoContent)`
  width: 100%;
  &:not(:first-child) {
    margin-top: 0.5rem;
  }
  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`

export const StyledPicture = styled(Picture)`
  &,
  & img {
    display: block;
    width: 100%;
    border-radius: 1rem;
    overflow: hidden;
  }
`

export const DesktopStyledPicture = styled(StyledPicture)`
  display: none;
  @media ${mq(sizes.tablet)} {
    display: block;
  }
`
export const MobileStyledPicture = styled(StyledPicture)`
  @media ${mq(sizes.tablet)} {
    display: none;
  }
`

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2rem;
  gap: 2rem;
`
export const Button = styled(ActionButton)`
  margin-top: 2rem;
`
